<template>
    <!--shopping cart area start -->
    <div class="shopping_cart_area pt-30">
        <div class="container">
            <form action="#">
                <div class="row">
                    <div class="col-12">
                        <div class="table_desc">
                            <div class="cart_page table-responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th class="product_check"></th>
                                            <th class="product_thumb">Hình ảnh</th>
                                            <th class="product_name">Sản phẩm</th>
                                            <th class="product-price">Đơn giá</th>
                                            <th class="product_quantity">Số lượng</th>
                                            <th class="product_total">Thành tiền</th>
                                            <th class="product_remove">Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="item in items">
                                            <tr :key="item.id">
                                                <td class="product_check"><input type="checkbox" v-model="item.checked"></td>
                                                <td class="product_thumb"><a :href="'/chi-tiet-san-pham/' + item.product_id"><img :src="(item.nhanh_id ? item.image : '/' + item.path) || '/assets/img/noimage.jpg'" alt=""></a></td>
                                                <td class="product_name">
                                                    <a :href="'/chi-tiet-san-pham/' + item.product_id">{{ item.name }}</a>
                                                </td>
                                                <td class="product-price">{{ item.price | currency }}</td>
                                                <td class="product_quantity"><input min="0" max="10000" v-model="item.qty" type="number" @change="updateItem({id: item.id, qty: item.qty})"></td>
                                                <td class="product_total">{{ item.line_price | currency }}</td>
                                                <td class="product_remove"><a @click="deleteItem(item.id)"><i class="fa fa-trash-o"></i></a></td>
                                            </tr>
                                            <tr :key="item.id">
                                                <td></td>
                                                <td colspan="6">
                                                    <v-text-field label="Ghi chú" class="red--text pa-0 ma-0 pt-1" v-model="item.note" @change="updateItem({id: item.id, note: item.note})"></v-text-field>
                                                </td>
                                            </tr>
                                        </template>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!--coupon code area start-->
                <div class="coupon_area">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="coupon_code left">
                                <h3>Thông tin giao hàng</h3>
                                <div class="coupon_inner">
                                    <v-form ref="form_checkout" v-model="valid" :autocomplete="autocomplete" style="border: none;">
                                        <v-checkbox label="Sử dụng địa chỉ theo thông tin tài khoản" v-model="default_address" @change="onCheckAddr"></v-checkbox>
                                        <v-text-field :rules="requireRules" :autocomplete="autocomplete" v-model="order_name" label="Người nhận"></v-text-field>
                                        <v-text-field :rules="phoneRules" :autocomplete="autocomplete" required v-model="order_phone" label="Số điện thoại"></v-text-field>
                                        <v-text-field :rules="requireRules" :autocomplete="autocomplete" v-model="order_address" label="Địa chỉ"></v-text-field>
                                        <!-- <v-textarea v-model="order_note" label="Ghi chú" rows="3"></v-textarea> -->
                                    </v-form>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="coupon_code right">
                                <h3>Tiền hàng</h3>
                                <div class="coupon_inner">
                                    <div class="cart_subtotal">
                                        <p>Tiền hàng</p>
                                        <p class="cart_amount">{{ summaryCart.total_amount | currency }}</p>
                                    </div>
                                    <div class="cart_subtotal ">
                                        <p>Cước vận chuyển</p>
                                        <p class="">Cập nhật sau</p>
                                    </div>

                                    <div class="cart_subtotal">
                                        <p>Tổng tiền</p>
                                        <p class="cart_amount">{{ summaryCart.total_amount | currency }}</p>
                                    </div>
                                    <v-checkbox class="py-0" label="Sử dụng địa chỉ cho lần sau" v-model="set_address"></v-checkbox>
                                    <v-text-field label="Ghi chú đơn hàng" v-model="order_note" class="input-group--focused py-0"></v-text-field>
                                    <div class="checkout_btn">
                                        <a @click="placeOrder">Lên đơn</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--coupon code area end-->
            </form>
        </div>
    </div>
    <!--shopping cart area end -->
</template>
<script>
import { mapState } from "vuex";
import { sendErrorNotice, loadingData } from '@/commons/utils'
import configs from "@/configs";
export default {
    data() {
        return {
            autocomplete: 'new-password',
            valid: false,
            phoneRules: [
                v => !!v || 'Hãy nhập số điện thoại',
                v => /^\d+$/.test(v) || 'Số điện thoại chỉ bao gồm các số 0-9',
                v => v.length === 10 || 'Số điện thoại có độ dài 10 chữ số'
            ],
            requireRules: [
                v => !!v || 'Hãy nhập thông tin giao hàng'
            ],
            order_note: '',
            default_address: false,
            set_address: false,
            order_name: '',
            order_phone: '',
            order_address: '',
            is_loading: false,
        }
    },
    computed: {
        ...mapState({
            loading: state => state.carts.loading,
            items: state => state.carts.all.data,
            totalCart: state => state.carts.all.total,
            customer: (state) => state.users.selected,
        }),
        summaryCart() {
            return {
                total_amount: _.sumBy(_.filter(this.items, {'checked': true}), "line_price")
            }
        },
        isAuthenticated() {
            return localStorage.getItem('jwt') !== null;
        },
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
        is_wholesale() {
            return this.$store.state.authentication.user.wholesale;
        },
    },
    methods: {
        refreshData() {
            if(!this.isAuthenticated) {
                window.getApp.$router.replace('/dang-nhap');
                return;
            }
            this.$store.dispatch("carts/getList")
            this.$store.dispatch("users/getDetail", this.customer_id);
        },
        updateItem(item) {
            if(item.qty <= 0) {
                window.getApp.$emit('REQUEST_DELETE_DATA', item.id);
                return;
            }
            this.$store.dispatch("carts/setDetail", {data: item, id: item.id})
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        onCheckAddr() {
            if(this.default_address) {
                this.order_name = this.customer.first_name;
                this.order_phone = this.customer.email;
                this.order_address = this.customer.address;
            }
            else {
                this.order_name = '';
                this.order_phone = '';
                this.order_address = '';
            }
        },
        placeOrder: _.debounce(function () {
            if(this.is_loading) { return; }
            if(!this.isAuthenticated) {
                window.getApp.$router.replace('/dang-nhap');
                return;
            }
            if (!this.$refs.form_checkout.validate()) {
                sendErrorNotice("Hãy kiểm tra lại dữ liệu đã nhập!");
                return;
            }
            let selected_items = _.filter(this.items, {'checked': true});
            if(selected_items.length == 0) {
                sendErrorNotice('Hãy chọn danh sách sản phẩm.');
                return;
            }
            this.is_loading = true;
            loadingData(this.is_loading);
            let totalQty = _.sumBy(selected_items, "qty");
            let totalAmount = _.sumBy(selected_items, "line_price");
            let isIgnore = _.find(selected_items, 'is_makeup');
            if(this.set_address) {
                this.$store.dispatch("users/setDetail", {data: {email: this.order_phone, first_name: this.order_name, address: this.order_address}, id: this.customer_id});
            }
            this.$store.dispatch("orders/setDetail", {data: {
                qty: totalQty,
                order_note: this.order_note,
                order_name: this.order_name,
                order_phone: this.order_phone,
                order_address: this.order_address,
                ignore_sync: isIgnore,
                products: _.map(selected_items,(item) => {
                    return {
                        product_id: item.product_id,
                        nhanh_id: item.nhanh_id,
                        price: item.price,
                        qty: item.qty,
                        name: item.name,
                        note: item.note
                    };
                }),
                sub_total: totalAmount,
                total: totalAmount,
            }}).then((ret) => {
                this.is_loading = false;
                this.$store.dispatch("carts/removeBath", {'product_ids': _.map(selected_items, 'id')} );
                window.getApp.$router.push(`/dat-hang-thanh-cong/${ret.data.id}`);
            });
        }, 5000, {'leading': true})
    },
    mounted() {
        this.refreshData();
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("carts/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
}
</script>